export const API_BASE_PROD = "https://api-xcx.qunsou.co";
export const API_BASE_PRE = "https://pre.weiyoubot.cn";
export const API_BASE_STORAGE_KEY = "xqd_api_base_url";

const resolveBaseUrl = () => {
	if (typeof window === "undefined") {
		return API_BASE_PROD;
	}
	const saved = window.localStorage.getItem(API_BASE_STORAGE_KEY) || "";
	if (saved === API_BASE_PRE || saved === API_BASE_PROD) {
		return saved;
	}
	return API_BASE_PROD;
};

var baseUrl = resolveBaseUrl();

var checkin = {
	upload: '/xcx/checkin_web/v1/upload', //新增的上传文件，感觉用不上了
	uploadPic: '/xcx/file/v1/upload', //小程序的上传图片
	uploadAudio: '/xcx/audio/upload',//小程序的上传语音
	uploadVideo: '/xcx/checkin/v1/upload/video',//小程序的上传视频
	loginQr: '/xcx/checkin_web/v1/qrcode', // PC扫码登录二维码
	loginCheckStatus: '/xcx/checkin_web/v1/check_status', // PC扫码登录状态
	pcTicket: '/xcx/checkin_web/v1/pc_ticket', // PC OpenSDK 拉起小程序 ticket
	getCheckinDetail: '/xcx/checkin/v5/detail', //获取签到详情
	getNoDetail: '/xcx/checkin/v5/detail_noauth',//免登录详情
	getShareCode: '/xcx/checkin/v1/noauth_share', //免登录获取小程序码
	shareConfig: '/xcx/checkin/v2/share', // 分享配置
	joinCheckin: '/xcx/checkin/v5/join', //加入签到
	submit: '/xcx/checkin/v3/doit', //发布签到
	homeworkList: '/xcx/checkin/v1/homework/list', // 任务列表
	homeworkDetail: '/xcx/checkin/v2/homework/detail', // 任务详情
	homeworkSubmit: '/xcx/checkin/v1/homework/submit', // 提交任务
	homeworkRank: '/xcx/checkin/v1/homework/rank', // 班级作业已提交/未提交名单
	homeworkRankCopy: '/xcx/checkin/v2/homework/rank', // 复制名单接口
	rankList: '/xcx/checkin/v6/rank', // 排行榜
	personal: '/xcx/checkin/v5/personal', // 个人签到页
	personalRecords: '/xcx/checkin/v1/personal/records', // 个人中心-签到记录列表
	picText: '/xcx/checkin/v3/pic_text', // 签到记录
	myCheckins: '/xcx/checkin/v3/list', // 我的签到列表
	myHistory: '/xcx/checkin/v1/user/history', // 最近浏览
	aggregateDetail: '/xcx/checkin/v1/simple/detail', // 聚合签到详情
	removeCheckin: '/xcx/checkin/v3/remove', // 删除签到
	removeCheckinRecords: '/xcx/checkin/v1/infos/remove', // 清空签到记录
	exitCheckin: '/xcx/checkin/v5/exit', // 退出签到
	myRemovedCount: '/xcx/checkin_web/v3/checkins', // 回收站数量
	recoverCheckin: '/xcx/checkin/v1/recover', // 回收站恢复签到
	removePermanently: '/xcx/checkin/v1/remove/permanently', // 回收站彻底删除
	checkTop: '/xcx/checkin/v1/check_top', // 我的签到置顶/取消置顶
	getQr: '/xcx/checkin/v3/qrcode', // 获取签到二维码（带活动标题的小程序码）
	getQrocde: '/xcx/checkin/v1/qrcode', // 获取签到二维码（免登录的活动小程序码）
	userInfo: '/xcx/checkin/v2/userinfo', // 个人中心用户信息
	vipDev: '/xcx/checkin/v3/vip', // 个人中心开发者权限
	vipLogin: '/xcx/checkin/v1/vip_login', // 个人中心用户身份登录
	noticeCount: '/xcx/checkin/v1/msg_num', // 通知首页四类消息未读数
	noticeMessages: '/xcx/checkin/v4/messages', // 评论、审核、赞赏消息列表
	commentSubmit: '/xcx/checkin/v3/add_com', // 提交评论/回复评论
	officialNoticeList: '/xcx/checkin/v1/sys/list', // 官方消息列表
	noticeAudit: '/xcx/checkin/v1/message/audit', // 审核消息同意/拒绝
	makeupManage: '/xcx/checkin/v1/makeup/manage', // 补签审核同意/拒绝
}

const apiConfig = {
	baseUrl,
	checkin,
};

export const setApiBaseUrl = (targetUrl) => {
	if (targetUrl !== API_BASE_PROD && targetUrl !== API_BASE_PRE) {
		return apiConfig.baseUrl;
	}
	apiConfig.baseUrl = targetUrl;
	if (typeof window !== "undefined") {
		window.localStorage.setItem(API_BASE_STORAGE_KEY, targetUrl);
	}
	return apiConfig.baseUrl;
};

export default apiConfig;



// WEBPACK FOOTER //
// ./src/utils/api.js